<template>
  <div class="status_popover">
    <div class="p-3" v-if="popup_type == 'status_change' " :class="(view_type == 'mobile') ? 'popover_mobile_content' : 'popover_content'" >

        <h4><b>Mark as {{action}}?</b>
            <img v-on:click="cancelStatus" class="pull-right point_cursor" src="../assets/images/icons/close_icon.svg">
        </h4>

        <hr class="mt-0">

        <p class="font-20" v-if="(this.$session.get('multi_book_id') == 0)">

            <span v-if="(action == 'Booked') || (action == 'Arrived')">Are you sure you want to change booking status to {{action}} ?</span>

            <span  v-else>Please note that you won't be able to change status again for this booking.</span>
        </p>

        <p class="font-20" v-else>

            <span v-if="(action == 'Booked') || (action == 'Arrived')">Please note that this will apply to all other services in this booking.</span>

            <span v-else>Please note that this status will apply to all other services in this booking. And you won't be able to change status again for this booking.</span>  

        </p>

        <!-- <p class="green">Note: if you want to make status changes to single service, you can use clipboard feature to reschedule first and to create new booking with the services you want, then make changes to the service.</p> -->
        
        <div class="row" v-if="view_type == 'mobile'">
            <div class="col-12">
                <hr>
            </div>
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-ash btn-rounded"  @click="cancelStatus">Cancel</button>
            </div>
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-pink btn-rounded btn_ash_shadow" @click="updateStatus(value)">Confirm</button>
            </div>
        </div>

        <div class="row" v-else>
            <div class="col text-right">
                <button type="button" class="btn btn-lg btn-ash btn-rounded mx-3"  @click="cancelStatus">Cancel</button>
                <button type="button" class="btn btn-lg btn-pink btn-rounded mx-3 btn_ash_shadow" @click="updateStatus(value)">Confirm</button>
            </div>
        </div>

    </div>

     <!-- START: Service remove in edit booking popup  -->
    <div class="p-3 popover_content" v-else-if="popup_type == 'service_remove'">

        <h4><b>Remove {{service_type}}?</b>
            <img v-on:click="closeServicePopUp" class="pull-right point_cursor" src="../assets/images/icons/close_icon.svg">
        </h4>

        <hr class="mt-0">

        <p class="font-20">Are you sure to remove this service from booking, please note that this change is not reversible.</p>

        <!-- <p class="green font-14">Note: if you remove this {{service_type}}, it will be no longer associated with this booking and no history recorded further for this service.</p> -->
        
        <div class="row">
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-ash btn-rounded"  @click="closeServicePopUp"><b>Don't Remove</b></button>
            </div>
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-pink btn-rounded btn_ash_shadow" @click="removeService"><b>Remove</b></button>
            </div>
        </div>
    </div>
    <!-- END: Service remove in edit booking popup  -->

    <!-- START: Delete product -->
    <div class="p-3 popover_content" v-else-if="popup_type == 'delete_product'">

        <h4><b>Delete Product?</b>
            <img v-on:click="closeServicePopUp" class="pull-right point_cursor" src="../assets/images/icons/close_icon.svg">
        </h4>

        <hr class="mt-0">

        <p class="font-20">Are you sure to delete this product, please note that this change is not reversible.</p>

        <div class="row pt-2">
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-ash btn-rounded"  @click="closeServicePopUp"><b>Cancel</b></button>
            </div>
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-pink btn-rounded btn_ash_shadow" @click="removeService"><b>Delete</b></button>
            </div>
        </div>
    </div>
    <!-- END: Delete product -->
    
    <!-- START: Discard Changes -->
    <div class="p-3 popover_content" v-else-if="popup_type == 'Discard_Changes'">

        <h4><b>Discard changes?</b>
            <img v-on:click="closeServicePopUp" class="pull-right point_cursor" src="../assets/images/icons/close_icon.svg">
        </h4>

        <hr class="mt-0">

        <p class="font-20">Are you sure you want to discard all the changes you made to this product.</p>

        <div class="row pt-2">
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-ash btn-rounded"  @click="closeServicePopUp"><b>Cancel</b></button>
            </div>
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-pink btn-rounded btn_ash_shadow" @click="discard_changes"><b>Discard</b></button>
            </div>
        </div>
    </div>
    <!-- END: Discard Changes -->

     <!-- START: remove product -->
    <div class="p-3 popover_content" v-else-if="popup_type == 'product_remove'">

        <h4><b>Remove Product?</b>
            <img v-on:click="closeServicePopUp" class="pull-right point_cursor" src="../assets/images/icons/close_icon.svg">
        </h4>

        <hr class="mt-0">

        <p class="font-20">Are you sure to remove this product from booking, please note that this change is not reversible.</p>

        <div class="row pt-2">
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-ash btn-rounded"  @click="closeServicePopUp"><b>Cancel</b></button>
            </div>
            <div class="col">
                <button type="button" class="btn btn-lg btn-block btn-pink btn-rounded btn_ash_shadow" @click="remove_product"><b>Remove</b></button>
            </div>
        </div>
    </div>
    <!-- END: remove product -->

    <!-- START: Event dragged to clipboard is not allowed Alert  -->
    <div v-else-if="popup_type == 'non_draggable_event_to_clipboard'" class="p-3 popover_content">
        <h4>
            <b>Reschedule</b>
            <img @click="$emit('close')" class="pull-right point_cursor" src="../assets/images/icons/close_icon.svg">
        </h4>

        <hr class="mt-0">
        <p class="ash font-20"><b>Note</b></p>
        <p class="font-20">Only bookings with status <b>Booked, Arrived</b> are allowed to reschedule.</p>

        <button type="button" class="btn btn-lg btn-ash btn-rounded pull-right"  @click="$emit('close')">
            <b>Close</b>
        </button>
    </div>
    <!-- END: Event dragged to clipboard is not allowed Alert  -->


    <!-- START: Discard Clipboard Popup  -->
    <div v-else-if="popup_type == 'discard_clipboard'" class="p-4 discard_popover_content">

        <h4>
            <b>Restore Bookings?</b>
            <img @click="$emit('close')" class="pull-right point_cursor" src="../assets/images/icons/close_icon.svg">
        </h4>

        <hr class="mt-0">
        <p class="font-20 text-center"> Closing the clipboard will restore the bookings back to the original time slots.</p>

        <!-- <div class="col-md-12">
            <button type="button" class="btn btn-lg btn-block btn-blue btn-rounded btn_ash_shadow" @click="$emit('close')"><b>Continue Rescheduling</b></button>
        </div> -->
        <div class="col-md-12 pt-3">
            <button type="button" class="btn btn-lg btn-block btn-blue btn-rounded btn_ash_shadow" @click="clear_events_in_clipboard"><b>Close & Restore</b></button>
        </div>

    </div>
    <!-- END: Discard Clipboard Popup  -->

    <!-- START: Staff move warning (JOYWEB-2626) -->
    <div v-else-if="popup_type == 'staff_move_warning'" class="staff_move_content">
        <div class="smh">
            <h4 class="m-0"><b>Move {{move_meta.customerName}} to {{move_meta.staffName}}?</b></h4>
            <span v-if="move_meta.fromStaffName && move_meta.fromStaffName != move_meta.staffName" class="smchg">
                <span class="smchgic" v-html="userIcon"></span>{{move_meta.fromStaffName}} <span class="smchgar">→</span> <b>{{move_meta.staffName}}</b>
            </span>
            <p class="smsub">{{move_meta.serviceCount == 2 ? 'Both' : 'All ' + move_meta.serviceCount}} back-to-back services move together — new times:</p>
        </div>
        <div class="smb">
            <div class="smslots">
                <div v-for="(s, si) in (move_meta.services || [])" :key="'s'+si" class="smslot">
                    <span class="smdot">{{si + 1}}</span>
                    <span class="smsname">{{s.servName}}</span>
                    <span class="smstime"><span class="smold">{{min2str(s.oldStartMin)}}–{{min2str(s.oldEndMin)}}</span><span class="smar">→</span><b>{{min2str(s.startMin)}}–{{min2str(s.endMin)}}</b></span>
                </div>
            </div>
            <div v-for="(w, i) in warnings" :key="i" class="smrow" :class="w.type">
                <span class="smic" v-html="iconFor(w.type)"></span>
                <span class="smtext">
                    <span class="smtitle">{{titleFor(w)}}</span>
                    <span class="smdetail">{{detailFor(w)}}</span>
                    <a v-if="w.type === 'service'" :href="staffServicesUrl" target="_blank" rel="noopener" class="smlink">Edit {{move_meta.staffName}}’s services ↗</a>
                </span>
            </div>
            <p v-if="warnings.length" class="smnote">Just a heads-up — you can still go ahead if it’s fine.</p>
            <p v-else class="smclear">✓ {{move_meta.staffName}} is free at this time — no timing or booking conflicts.</p>
        </div>
        <div class="smf">
            <button type="button" class="btn btn-ash btn-rounded" @click="moveCancel"><b>Cancel</b></button>
            <button type="button" class="btn btn-blue btn-rounded btn_ash_shadow ml-2" @click="moveConfirm"><b>{{warnings.length ? 'Continue anyway' : 'Continue to edit'}}</b></button>
        </div>
    </div>
    <!-- END: Staff move warning -->

  </div>
</template>

<script>
export default {
    name: 'popover',
    data(){
        return {
        }
    },
    props: {
        action : String,
        value : Number,
        view_type : String,
        popup_type : String,
        service_type : String,
        serv_index: Number,
        // JOYWEB-2626 staff-move warning dialog
        warnings: { type: Array, default: () => [] },
        move_meta: { type: Object, default: () => ({}) }
    },
    computed: {
        // JOYWEB-2626: person icon for the "from staff -> to staff" chip.
        userIcon() {
            // width/height set on the element itself — scoped CSS can't reach v-html content.
            return '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>';
        },
        // JOYWEB-2626: shortcut to the legacy staff↔service mapping settings page. Same URL the
        // Settings screen uses. Opened in a new tab so the admin doesn't lose the calendar.
        // Permanently mapping the service is Phase 2 (inline); for now this is just the link out.
        staffServicesUrl() {
            return window.location.origin + '/index.php/settings/staff_service_mapping';
        }
    },
    methods:{
        // ===== JOYWEB-2626 staff-move warning dialog =====
        moveConfirm() { this.$emit('moveConfirm'); },
        moveCancel() { this.$emit('moveCancel'); },
        // minutes-since-midnight -> "10:45 AM"
        min2str(min) {
            if (typeof min !== 'number' || isNaN(min)) return '';
            var h = Math.floor(min / 60), m = min % 60, ap = h < 12 ? 'AM' : 'PM';
            var hh = h % 12; if (hh === 0) hh = 12;
            return hh + (m ? (':' + (m < 10 ? '0' + m : m)) : '') + ' ' + ap;
        },
        iconFor(type) {
            // width/height set inline — scoped CSS can't size v-html SVGs (they'd default to 300x150).
            var svg = 'width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"';
            if (type === 'service') return '<svg ' + svg + '><path d="M18 11V6a2 2 0 0 0-4 0"/><path d="M14 10V4a2 2 0 0 0-4 0v2"/><path d="M10 10.5V6a2 2 0 0 0-4 0v8"/><path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-6-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"/></svg>';
            if (type === 'timing') return '<svg ' + svg + '><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
            return '<svg ' + svg + '><rect x="3" y="3" width="12" height="12" rx="2.5"/><rect x="9" y="9" width="12" height="12" rx="2.5"/></svg>';
        },
        titleFor(w) {
            var s = this.move_meta.staffName;
            if (w.type === 'service') return s + ' doesn’t offer ' + w.servName;
            if (w.type === 'timing') return s + ' isn’t working then';
            return 'Booking clash';
        },
        detailFor(w) {
            if (w.type === 'service') return 'This service isn’t on ' + this.move_meta.staffName + '’s list yet.';
            if (w.type === 'timing') return 'Works ' + this.min2str(w.workStartMin) + '–' + this.min2str(w.workEndMin) + '; the visit is ' + this.min2str(w.visitStartMin) + '–' + this.min2str(w.visitEndMin) + '.';
            return 'Overlaps ' + w.custName + ' · ' + w.servName + ' (' + this.min2str(w.startMin) + '–' + this.min2str(w.endMin) + ').';
        },

        async updateStatus(status){
            await this.$store.dispatch('service_status_update',[this.$session.get('book_id'),this.$session.get('multi_book_id')?this.$session.get('multi_book_id'):0,status,this.$store.state.user_id,this.Constants.BOOKED_THROUGH_ADMIN]);
            this.$emit('changePopStatus');
        },

        cancelStatus(){
            this.$emit('cancelPopStatus');
        },

        removeService(){
            this.$emit('removeService','Delete');
        },
        discard_changes(){
            this.$emit('removeService','Discard');
        },
        closeServicePopUp(){
            this.$emit('closePopUp');
        },

        clear_events_in_clipboard() { 
            this.$emit('clear_events_in_clipboard'); 
        },
        remove_product(){
            this.$emit('remove_product_from_booking')
        }

    }
}
</script>

<style scoped>
    .status_popover{
        position: fixed;
        z-index: 2000;
        top:0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0,0,0,0.4);
    }

    .popover_content{
        position: absolute;
        top: 30%;
        left: 35%;
        width: 30%;
        background: #ffffff;
        border-radius: 6px;
    }

    .popover_mobile_content{
        position: absolute;
        width: 100%;
        bottom: 0;
        background: #ffffff;
        border-radius: 6px 6px 0 0;
    }

    .discard_popover_content{
        position: absolute;
        top: 30%;
        left: 37%;
        width: 25%;
        background: #ffffff;
        border-radius: 6px;
    }

    /* JOYWEB-2626 staff-move warning dialog */
    .staff_move_content{
        position:absolute; top:12%; left:50%; transform:translateX(-50%);
        width:440px; max-width:92%; background:#fff; border-radius:14px; overflow:hidden;
        box-shadow:0 20px 60px rgba(16,24,40,.3);
    }
    .staff_move_content .smh{ padding:18px 20px 6px; }
    .staff_move_content .smh h4{ font-size:17px; }
    .staff_move_content .smsub{ color:#7C8495; font-size:12.5px; margin:8px 0 0; text-wrap:pretty; }
    /* staff-change chip */
    .staff_move_content .smchg{ display:inline-flex; align-items:center; gap:6px; margin-top:8px; font-size:12.5px; color:#123; background:#eef6ff; border:1px solid #d5e8fb; border-radius:20px; padding:3px 10px; }
    .staff_move_content .smchgic{ display:flex; color:#0084F4; }
    .staff_move_content .smchgic svg{ width:13px; height:13px; display:block; }
    .staff_move_content .smchgar{ color:#9aa4b2; }
    .staff_move_content .smchg b{ color:#292929; }
    /* slot list (old -> new) */
    .staff_move_content .smslots{ border:1px solid #EBEFF2; border-radius:12px; overflow:hidden; box-shadow:0px 2px 10px rgba(0,0,0,.05); margin-bottom:12px; }
    .staff_move_content .smslot{ display:flex; align-items:center; gap:11px; padding:11px 13px; font-size:13px; }
    .staff_move_content .smslot + .smslot{ border-top:1px solid #EBEFF2; }
    .staff_move_content .smdot{ flex:0 0 22px; height:22px; border-radius:6px; background:#eaf6ff; border:1px solid #cfe6ff; color:#0084F4; display:flex; align-items:center; justify-content:center; font-weight:700; font-size:11px; }
    .staff_move_content .smsname{ font-weight:600; color:#292929; }
    .staff_move_content .smstime{ margin-left:auto; color:#7C8495; font-size:12px; white-space:nowrap; }
    .staff_move_content .smstime .smold{ text-decoration:line-through; opacity:.7; }
    .staff_move_content .smstime .smar{ margin:0 4px; color:#9aa4b2; }
    .staff_move_content .smstime b{ color:#292929; font-weight:700; }
    .staff_move_content .smb{ padding:8px 20px 14px; }
    .staff_move_content .smrow{
        display:flex; gap:11px; padding:12px 14px; border-radius:12px;
        border:1px solid #EBEFF2; align-items:flex-start; margin-bottom:9px;
        box-shadow:0px 2px 10px rgba(0,0,0,.05);
    }
    .staff_move_content .smrow:last-of-type{ margin-bottom:0; }
    .staff_move_content .smrow.service{ background:#FEF6EC; border-color:#F6E1C4; }
    .staff_move_content .smrow.timing, .staff_move_content .smrow.availability{ background:#FEEFF1; border-color:#F8CDD2; }
    .staff_move_content .smic{ flex:0 0 18px; margin-top:1px; display:flex; }
    .staff_move_content .smic svg{ width:18px; height:18px; display:block; }
    .staff_move_content .smrow.service .smic{ color:#F2994A; }
    .staff_move_content .smrow.timing .smic, .staff_move_content .smrow.availability .smic{ color:#FB6672; }
    .staff_move_content .smtext{ min-width:0; display:flex; flex-direction:column; }
    .staff_move_content .smtitle{ font-weight:600; font-size:13px; line-height:1.35; color:#292929; }
    .staff_move_content .smdetail{ color:#7C8495; font-size:12.5px; line-height:1.5; margin-top:2px; text-wrap:pretty; }
    .staff_move_content .smlink{ align-self:flex-start; margin-top:6px; color:#0084F4; font-size:12.5px; font-weight:600; text-decoration:none; }
    .staff_move_content .smlink:hover{ text-decoration:underline; }
    .staff_move_content .smnote{ font-size:12px; color:#7C8495; margin:10px 0 0; line-height:1.5; text-wrap:pretty; }
    .staff_move_content .smclear{ padding:12px 0; color:#10A377; font-size:13px; line-height:1.5; margin:0; }
    .staff_move_content .smf{
        display:flex; justify-content:flex-end; padding:14px 20px;
        background:#fafbfc; border-top:1px solid #EBEFF2;
    }
</style>